import { EVENT_SOURCE } from '../../constants/analytics';

import { type CommonAttributes } from './types';

type onDropdownResultClickedArgs = {
	commonAttributes: CommonAttributes;
	socialSignal: string;
};

export const onSocialSignalClickedAnalyticsContext: ({
	commonAttributes,
	socialSignal,
}: onDropdownResultClickedArgs) => {
	eventType: string;
	source: string;
	attributes: {
		isFullPageSearch: boolean;
		socialSignal: string;
		filters: string[];
		filterSelections: import('./types').FilterSelectionType[];
		searchSessionId: string;
		traceId?: string;
		productSelected: string;
		availableProducts: string[];
		mode: string;
		has3pProducts: boolean;
		is3pSearch: boolean;
		numberOfTerms: number;
		queryLength: number;
		inputQueryLength: number;
		queryHash: string;
		containerStatuses: string[];
		contentStatuses: string[];
		abTest?:
			| import('@atlassian/search-client').AggAbTest
			| import('@atlassian/search-experiment').BackendExperiment;
		frontendExperiments:
			| import('@atlassian/search-experiment').FrontendExperiments
			| {
					activeExperiments: string[];
			  };
		backendExperiments?: import('@atlassian/search-experiment').BackendExperiment;
		version: number;
		api: string;
		wordCount: number;
		isCQL: boolean;
		queryUpdatedAgo?: number;
		sort: import('@atlassian/search-client').ResultsSort;
		productEdition?: import('@atlassian/search-experiment').ProductEdition;
		isSearchPageRelay?: boolean;
	};
} = ({ commonAttributes, socialSignal }: onDropdownResultClickedArgs) => ({
	eventType: 'ui',
	source: EVENT_SOURCE,
	attributes: {
		...commonAttributes,
		isFullPageSearch: true,
		socialSignal,
	},
});
